var menuInited = false;
define('app/views/navigation_view',['app/setup'], function(takhfifan) {
  takhfifan.NavigationView = Backbone.View.extend({
    events: {
      'mouseenter li' : 'activateSubMenu',
      'mouseleave' : 'deActivateSubMenu'
    },

    activateSubMenu: function(evt) {
      var target = $(evt.target).is('li') ? $(evt.target).find('a') : $(evt.target).parents('li').find('a');
      if (!target.hasClass('tkh-navigation-item')) {
        return;
      }
      var $chosen = $(evt.target).closest('li');
      this.gatherImpressionData($chosen);

      this.$('li').removeClass('active');
      this.$('.sub-nav').hide();
      this.$('.sub-nav-min').hide();

      $chosen.toggleClass('active');
      $chosen.find('.sub-nav').first().show();
      $chosen.find('.sub-nav-min').first().show();

      this.loadHqImage($chosen);
      return false;
    },

    deActivateSubMenu: function(evt) {
      this.$('li').removeClass('active');
      this.$('.sub-nav').hide();
      this.$('.sub-nav-min').hide();
    },

    loadHqImage: function($container) {
      $container.find('img.tkh-lazy-hidden').each(function() {
        var $img = $(this);
        $img.prop('src', $img.data('src'));
        $img.removeClass('tkh-lazy-hidden');
      });
    },

    gatherImpressionData: function ($el) {
      var dealsData = [];
      $el.find('.menu-deal:not(".ga-impressed")').each(function(){
        var $this = $(this);
        dealsData.push($this.data('details'));
        $this.addClass('ga-impressed');
      });
      if(dealsData.length){
        takhfifan.eventHub.trigger('ga:promoImpression', dealsData);
      }
    }

  });
});

